module.exports = __webpack_public_path__ + "img/CRPT.a9af38e2.svg";